import { FormattedMessage } from 'react-intl';

import { AsnStatusTag } from '../../asn-status-tag';
import { advancedShippingNoticeGridProperties } from '../grid-properties';
import { messages } from '../messages';
import styles from './styles.module.less';

const name = <FormattedMessage {...messages.statusColumnHeader} />;

/**
 * Status column configuration
 * Displays the status with appropriate styling
 * Different statuses are displayed with different colors and visual indicators
 * @type {import('./types').GridColumn} Column configuration object
 */
export const statusColumn = {
  name,
  render: ({ status }) => <AsnStatusTag className={styles['status-tag-container']} status={status} />,
  id: advancedShippingNoticeGridProperties.status,
};
